<template>
  <v-app-bar
    fixed
    clipped-left
    dark
    app
    dense
    id="main-toolbar"
    >
      <v-app-bar-nav-icon  @click.stop="handleDrawerToggle"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title :to="{name: 'Dashboard'}" >        
        <v-img 
          class="logo-container"
          contain
          @click="toDashBoard"
          src="/static/logo-ligth-a.png" 
          height="20" alt="Ecotrace"></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn class="hidden-sm-and-down show-md-and-up" text :to="{name: 'Alerts'}">
        <v-badge color="red" right overlap v-if="$store.state.alerts > 0">
          <template v-slot:badge>
            <span v-if="$store.state.alerts > 9">9+</span>
            <span v-else>{{$store.state.alerts}}</span>
          </template>

          <v-icon>fa-bell</v-icon>
        </v-badge>
        <v-icon v-else>fa-bell</v-icon>
      </v-btn>

      <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        
        <template v-slot:activator="{ on }">
          <v-btn
            text
            v-on="on"
          >
            <v-avatar v-if="userPicture()" class="avatar-container mr-1" size="30px">
              
              <img :src="userPicture()">
            </v-avatar>
            <v-avatar v-else size="30px">
               <v-icon>fa-user-circle</v-icon>
            </v-avatar>
            <span class="hidden-sm-and-down">{{userName}}</span>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
             v-for="(item,index) in items" :to="!item.href ? { name: item.name } : null" :href="item.href" @click="item.click" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ item.title }}
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
  </v-app-bar>
</template>
<script>
import Vue from 'vue';
import Util from '@/util';
import menu from '@/router/paths';
import appApi from '../plugins/api'
export default {
  name: 'app-toolbar',
  components: {
    
  },
  data: () => ({
    userName : '',
    title: "",
    alerts: null,
    items: [
      {
        icon: 'account_circle',
        href: '#',
        title: 'Perfil',
        click: (e) => {
          Vue.router.push({name : 'Profile'});
        }
      },
      {
        icon: 'fullscreen_exit',
        href: '#',
        title: 'Sair',
        click: (e) => {
          window.getApp.$emit('APP_LOGOUT');
        }
      }
    ],
  }),
  mounted() { 
    const firtName = this.$auth.user().name ? this.$auth.user().name.split(' ')[0] : '' 
    this.userName = firtName
    this.getUserAlertsCount()
  },
  computed: {

    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    },
    showTitle() { 
      menu.forEach(item => {
        if (item.name === this.$route.name) {
          this.title = item.title;
        }
      });
      return this.title;
    }
  },
  methods: {
    handleDrawerToggle () {
      window.getApp.$emit('APP_DRAWER_TOGGLED');
    },
    handleFullScreen () {
      Util.toggleFullScreen();
    },
    userPicture() {
      if(this.$auth.user().picture) {
        return this.$auth.user().picture
      }
      return null
    },
    toDashBoard() {
      this.$router.push({name: 'Dashboard'})
    },

    getUserAlertsCount() {
      appApi.getHome()
      .then(result => {
        this.$store.state.alerts = result.data.userAlerts
      })
    },
  }
};
</script>

<style scoped lang="scss">
  #main-toolbar {
    background-image: linear-gradient(to bottom, #039be5, #0092e1, #0089dd, #0a7fd8, #1976d2);
  }
  #main-toolbar .v-toolbar__extension > .v-toolbar__title {
    margin-left: 0px;
  }

  #main-toolbar {
    .logo-container {
      cursor: pointer;
    }

    .avatar-container {
      img {
        max-width: 30px;
        max-height: 30px;
        border-radius: 50%;
      }
    }
  }
</style>

